
import { motion } from "motion/react";

export default function BlogBanner() {
  return (
    <div className="w-full  h-auto flex flex-col"> {/* Changed w-screen to w-full and added overflow-x-hidden */}
      <div className="w-full"> {/* Added w-full to contain children */}
        <div 
          className="flex justify-center relative w-full" 
          style={{ 
            backgroundImage: `url('https://dbqa318yoj3nn.cloudfront.net/blogbanner.png')`, 
            backgroundSize: 'cover', 
            backgroundPosition: 'center',
            overflow: 'hidden', // Added to prevent any overflow
            height: '412px', // Set a fixed height for the banner
            
          }}
        >
          <img 
            src='https://dbqa318yoj3nn.cloudfront.net/blogbanner2.png'
            alt="Front" 
            className="w-full sm:h-[600px] h-[400px] object-cover" // Changed w-screen to w-full
          />
          <div className="absolute mb-2 inset-0 flex flex-col items-center justify-end">
            <motion.h1 
              whileHover={{ scale: 1.1 }} 
              className="sm:text-6xl xs:text-2xl text-center md:text-4xl lg:text-6xl xs:font-medium font" 
              style={{ 
                fontFamily: "Montserrat", 
                color: "#FFDC4F", 
                textShadow: "2px 2px 4px rgba(255, 255, 255, 0.8)" 
              }}
            >
              Explore Ideas,Ignite Change
            </motion.h1>
          </div>
        </div>
      </div>
    </div>
  );
}